const wowApp = require('angular').module('oly.common');

wowApp.directive('olyInlineDropdown', ['$timeout', require('./inline-dropdown.directive')]);



// WEBPACK FOOTER //
// ./src/olycommon/dropdown/index.js